module.exports = __webpack_public_path__ + "img/arrow-left.435f5b6e.svg";